<template>
  <InvoiceCreateConceptManualMode
    v-show="resolvedSourceMode === SOURCE_MODE_MANUAL"
    :show="show && resolvedSourceMode === SOURCE_MODE_MANUAL"
    :mode="mode"
    :initial-data="initialData"
    :currency="currency"
    :show-mode-selector="showModeSelector"
    :source-mode="resolvedSourceMode"
    @close="$emit('close')"
    @submit="$emit('submit', $event)"
    @change-source-mode="setSourceMode"
  />

  <InvoiceCreateConceptPaymentPlanMode
    v-if="hasPaymentPlanContext"
    v-show="resolvedSourceMode === SOURCE_MODE_PAYMENT_PLAN"
    :show="show && resolvedSourceMode === SOURCE_MODE_PAYMENT_PLAN"
    :payment-id="prefillPaymentId"
    :existing-concepts="existingConcepts"
    :selected-receiver="selectedReceiver"
    :currency="currency"
    :show-mode-selector="showModeSelector"
    :source-mode="resolvedSourceMode"
    @close="$emit('close')"
    @submit="$emit('submit', $event)"
    @change-source-mode="setSourceMode"
  />
</template>

<script>
import InvoiceCreateConceptManualMode from '@/components/invoices/create/InvoiceCreateConceptManualMode.vue';
import InvoiceCreateConceptPaymentPlanMode from '@/components/invoices/create/InvoiceCreateConceptPaymentPlanMode.vue';

const SOURCE_MODE_MANUAL = 'manual';
const SOURCE_MODE_PAYMENT_PLAN = 'payment-plan';
const VALID_SOURCE_MODES = [SOURCE_MODE_MANUAL, SOURCE_MODE_PAYMENT_PLAN];

export default {
  name: 'InvoiceCreateConceptModal',
  components: {
    InvoiceCreateConceptManualMode,
    InvoiceCreateConceptPaymentPlanMode,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'create',
    },
    initialData: {
      type: Object,
      default: null,
    },
    existingConcepts: {
      type: Array,
      default: () => [],
    },
    currency: {
      type: String,
      default: 'MXN',
    },
    prefillPaymentId: {
      type: Number,
      default: 0,
    },
    selectedReceiver: {
      type: Object,
      default: null,
    },
  },
  emits: ['close', 'submit'],
  data() {
    return {
      activeSourceMode: SOURCE_MODE_MANUAL,
    };
  },
  computed: {
    SOURCE_MODE_MANUAL() {
      return SOURCE_MODE_MANUAL;
    },
    SOURCE_MODE_PAYMENT_PLAN() {
      return SOURCE_MODE_PAYMENT_PLAN;
    },
    isEditMode() {
      return String(this.mode || '').trim().toLowerCase() === 'edit';
    },
    hasPaymentPlanContext() {
      return Number(this.prefillPaymentId || 0) > 0 && !this.isEditMode;
    },
    showModeSelector() {
      return this.hasPaymentPlanContext;
    },
    resolvedSourceMode() {
      if (this.hasPaymentPlanContext && this.activeSourceMode === SOURCE_MODE_PAYMENT_PLAN) {
        return SOURCE_MODE_PAYMENT_PLAN;
      }

      return SOURCE_MODE_MANUAL;
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(visible) {
        if (!visible) {
          this.activeSourceMode = SOURCE_MODE_MANUAL;
          return;
        }

        this.activeSourceMode = this.defaultSourceMode();
      },
    },
    hasPaymentPlanContext(nextValue) {
      if (!nextValue && this.activeSourceMode === SOURCE_MODE_PAYMENT_PLAN) {
        this.activeSourceMode = SOURCE_MODE_MANUAL;
      }
    },
  },
  methods: {
    defaultSourceMode() {
      return this.hasPaymentPlanContext ? SOURCE_MODE_PAYMENT_PLAN : SOURCE_MODE_MANUAL;
    },
    normalizeSourceMode(nextMode) {
      const normalizedMode = String(nextMode || '').trim().toLowerCase();
      return VALID_SOURCE_MODES.includes(normalizedMode) ? normalizedMode : '';
    },
    setSourceMode(nextMode) {
      const normalizedMode = this.normalizeSourceMode(nextMode);
      if (normalizedMode === '') {
        return;
      }

      if (normalizedMode === SOURCE_MODE_PAYMENT_PLAN && !this.hasPaymentPlanContext) {
        return;
      }

      this.activeSourceMode = normalizedMode;
    },
  },
};
</script>
